import { Title } from "@components/atoms/Title";
import { Button } from "@components/atoms";
import type { ReactNode } from "react";

interface ReviewCardProps {
  title: string;
  subtitle: string;
  info: Array<{ label: string; value: string | ReactNode }>;
  onPrimaryAction: () => void;
  onSecondaryAction: () => void;
  primaryActionLabel?: string;
  secondaryActionLabel?: string;
  headerLabel?: string;
  disabled?: boolean;
  viewUserLabel?: string;
  onSeeUser?: () => void;
  createNewAccount?: boolean;
}

export function ReviewCard({
  title,
  subtitle,
  info,
  onPrimaryAction,
  onSecondaryAction,
  primaryActionLabel = "Salvar",
  secondaryActionLabel = "Voltar",
  viewUserLabel = "Acessar conta",
  headerLabel = "Cliente",
  disabled,
  onSeeUser,
  createNewAccount,
}: ReviewCardProps) {
  return (
    <div className="p-4">
      <Title title={title} subtitle={subtitle} />

      <div className="mt-4 border rounded-md overflow-hidden border-gray-300">
        <div className="bg-gray-50 px-4 py-2 font-semibold text-sm">{headerLabel}</div>
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {info.map((item, idx) => (
            <div
              key={idx}
              className={`grid grid-cols-2 px-4 py-2 text-sm ${idx % 2 === 0 ? "bg-white" : "bg-[#F8F9F9]"}`}
            >
              <span className="text-gray-500 font-medium">{item.label}</span>
              <span className="text-gray-800 font-medium text-xs">{item.value || "-"}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="fixed bottom-0 left-0 w-full bg-white p-4 border-t border-gray-200">
        <div className="flex flex-col gap-2">
          <Button isPrimary onClick={onPrimaryAction} disabled={disabled}>
            {primaryActionLabel}
          </Button>
          {!createNewAccount && (
            <Button isPrimary onClick={onSeeUser}>
              {viewUserLabel}
            </Button>
          )}
          <Button onClick={onSecondaryAction}>
            {secondaryActionLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}